import { ValidatorFn, Validators } from '@angular/forms';

export function PostOfficeValidator(): ValidatorFn {
  return Validators.pattern('^[A-ZŻŹĆĄŚĘŁÓŃ]{1}[a-zżźćąśęłóńA-ZŻŹĆĄŚĘŁÓŃ \\-]*$');
}
